import React, { FC, ReactNode } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const ChosenPriceDisabledTooltip: FC<{
  children?: ReactNode;
  phaseLevelPricing: boolean;
  topDownPricing: boolean;
}> = ({ children, phaseLevelPricing, topDownPricing }) => {
  const title = topDownPricing
    ? "Alter the User Defined total by adjusting the fee / hours targets in the Top Down Pricing tab."
    : phaseLevelPricing
    ? "Alter the User Defined total by adjusting the figures in the main workspace at individual phase level"
    : "Alter the User Defined total by adjusting the figures at the individual phase level below";

  return (
    <Tooltip title={title} placement="top">
      {children}
      <InfoCircleOutlined style={{ marginLeft: 5 }} />
    </Tooltip>
  );
};
